// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emiPlansTable.MuiTableCell-root {
    padding: 10px;
}

.noDataDiv {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 0px;
}

.noDataToDisplay.MuiTypography-root {
    font-size: 16px;
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    color: var(--text-high, rgba(1, 1, 2, 0.72));
}

.noDataSubText.MuiTypography-root {
    font-family: "Poppins";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
}

.emiTenure {
    color: var(--Global-Neutral-Grey-1100, #2D2B32);
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    margin-left: 12px;
}

.MuiTableCell-root {
    border-bottom: transparent !important;
}

.offerActive {
    padding: 0.3rem 0.5rem;
    font-size: 9px;
    font-weight: 700;
    color: #2e2c8d;
    background: #E4E4FF;
    margin-left: 0.5rem;
    border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/reusableComponents/offerManagement/emiPlans/emiPlans.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,+CAA+C;IAC/C,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB","sourcesContent":[".emiPlansTable.MuiTableCell-root {\n    padding: 10px;\n}\n\n.noDataDiv {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 50px 0px;\n}\n\n.noDataToDisplay.MuiTypography-root {\n    font-size: 16px;\n    font-family: Poppins;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n    color: var(--text-high, rgba(1, 1, 2, 0.72));\n}\n\n.noDataSubText.MuiTypography-root {\n    font-family: \"Poppins\";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n}\n\n.emiTenure {\n    color: var(--Global-Neutral-Grey-1100, #2D2B32);\n    font-family: Poppins;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    margin-left: 12px;\n}\n\n.MuiTableCell-root {\n    border-bottom: transparent !important;\n}\n\n.offerActive {\n    padding: 0.3rem 0.5rem;\n    font-size: 9px;\n    font-weight: 700;\n    color: #2e2c8d;\n    background: #E4E4FF;\n    margin-left: 0.5rem;\n    border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
